// QR Kiosk v2 — centered dashed empty-state card.
// Ported from designer kiosk2-states.jsx `EmptyCard`. Tokens only.
// `hint` is widened to ReactNode so consumers (e.g. KioskV2Placeholder) can pass
// a mono route-path element as the hint; `title` stays a plain string.
import React from "react";
import { Glyph } from "./glyphs";

export interface EmptyCardProps {
  glyph: string;
  title: string;
  hint: React.ReactNode;
  action?: React.ReactNode;
}

export function EmptyCard({ glyph, title, hint, action }: EmptyCardProps) {
  return (
    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div
        style={{
          width: "100%",
          border: "1px dashed var(--border)",
          borderRadius: 14,
          background: "var(--card)",
          padding: "30px 22px",
          textAlign: "center",
        }}
      >
        <div style={{ color: "var(--faint)", display: "flex", justifyContent: "center" }}>
          <Glyph d={glyph} size={28} />
        </div>
        <div style={{ fontSize: 15.5, fontWeight: 700, color: "var(--ink)", marginTop: 11 }}>{title}</div>
        <div style={{ fontSize: 13, color: "var(--muted)", marginTop: 5, lineHeight: 1.5 }}>{hint}</div>
        {action}
      </div>
    </div>
  );
}

export default EmptyCard;
